import { request } from "../libs";

function fetchAggregators(domain) {
	return request(
		`/server/${domain}/aggregators`,
		{
			method: "GET"
		}
	)
		.then(res => res.json());
}

export default fetchAggregators;



// WEBPACK FOOTER //
// ./src/api/fetch-aggregators.js